import React from "react";
import styled from "styled-components";
import { Translation } from "../../../core/translate";
import { Button } from "@vitalsource/vstui";

const Styled = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    > * {
      :not(:last-child) {
        margin-bottom: 25px;
      }
    }
  `,
  Simplified: styled.div`
    font-size: 3rem;
    font-weight: bold;
  `,
  ContinueButton: styled(Button)`
    border-radius: 24px;
  `
};

class SimplifiedReaderUI extends React.Component {
  render() {
    return (
      <Styled.Container>
        <Styled.Simplified>
          <Translation id="responsive-mobile.simplified">
            We’ve simplified your mobile reader
          </Translation>
        </Styled.Simplified>
        <Translation id="responsive-mobile.open-on-computer">
          Open your reader on a computer for access to all study features.
        </Translation>
        <Styled.ContinueButton
          color="white"
          onClick={() => {
            Fraction.Reporter.noticeInteraction("interstitial-not-now");
            this.props.continueToMobileSite();
          }}
        >
          <Translation id="responsive-mobile.continue-to-mobile">
            Continue to Mobile Web
          </Translation>
        </Styled.ContinueButton>
      </Styled.Container>
    );
  }
}

export default SimplifiedReaderUI;
